// extracted by mini-css-extract-plugin
export var container = "styles-module__container___J4xNs";
export var progress = "styles-module__progress___GMUFH";
export var progressText = "styles-module__progressText___vvYQX";
export var uploadContent = "styles-module__uploadContent___xjX9M";
export var uploadHeader = "styles-module__uploadHeader___qwOse";
export var uploadSubtext = "styles-module__uploadSubtext___0gmoQ";
export var uploading = "styles-module__uploading___t5OjG";